import React, { useEffect, useState, useRef } from 'react';
import { Form, Button, Image, FormGroup } from 'react-bootstrap';
import { Formik, Form as FormMik } from 'formik';
// eslint-disable-next-line import/no-duplicates
import { format, max } from 'date-fns';
import * as Yup from 'yup';
import { useSearchParams } from 'react-router-dom';
import { useToast } from '../hooks/toast';

import LogIcon from '../assets/icon/logWhite.svg';
import ResizeIcon from '../assets/icon/resize.svg';
import ResizeMaximizedIcon from '../assets/icon/resizeMaximized.svg';
import iconSearch from '../assets/icon/search.svg';
import api from '../services/apiClient';
import { getPrimeiroUltimoNome } from '../services/function';
import { formatLocalDateTime } from '../utils/dateTime';

interface Users {
  seqUsuario: number;
  nome: string;
}

interface TabelaLog {
  seqLogTabela: number;
  nome: string;
}

interface Log {
  seqLog: number;
  seqLogTabela: number;
  seqUsuario: number;
  user: string;
  nomeUsuario: string;
  operacao: string;
  dataOperacao: string;
  nomeTabela: string;
}

interface LogDetalhe {
  seqLog: number;
  seqLogDetalhe: number;
  campo: string;
  conteudoAnterior: string;
  conteudoAtual: string;
}

const dataFormatada = format(new Date(), 'yyyy-MM-dd');

interface FormField {
  periodoInicial: string;
  periodoFinal: string;
  seqUsuario: string;
  nomeUsuario: string;
  seqTabela: string;
}

const initialValues: FormField = {
  periodoInicial: dataFormatada,
  periodoFinal: dataFormatada,
  seqUsuario: '0',
  nomeUsuario: '',
  seqTabela: '0',
};

const ConfigLog = (): JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { addToast } = useToast();
  const [usuario, setUsuario] = useState<Users[]>([]);
  const [logTabela, setLogTabela] = useState<TabelaLog[]>([]);
  const [dataLog, setDataLog] = useState<Log[]>([]);
  const [dataLogDetalhe, setDataLogDetalhe] = useState<LogDetalhe[]>([]);
  const [logSelected, setLogSelected] = useState(0);
  const [maximizeLog, setMaximizeLog] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('@LiveChat:token');

    api
      .get('/api/user', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const { data: users } = response.data;
        setUsuario(users);
      });

    api
      .get('/api/log/logTable', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const { data: tabela } = response.data;
        setLogTabela(tabela);
      });
  }, []);

  const getLog = (dataFilter: FormField): void => {
    const token = localStorage.getItem('@LiveChat:token');

    setDataLog([]);
    setDataLogDetalhe([]);

    api
      .post('/api/log', dataFilter, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const { data: log } = response.data;

        if (log.length === 0) {
          addToast({
            title: 'Atenção',
            description: 'Não há registros para os filtros informados!',
            type: 'warning',
          });
        }

        setDataLog(log);
      });

    setLogSelected(0);
  };

  const getLogDetalhe = (seqLog: number): void => {
    const token = localStorage.getItem('@LiveChat:token');
    api
      .get(`/api/log/${seqLog}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const { data: logDetail } = response.data;
        setDataLogDetalhe(logDetail);
      });
  };

  const validationSchema = Yup.object().shape({
    periodoInicial: Yup.date().max(
      Yup.ref('periodoFinal'),
      'Data Inicial inválida.'
    ),
    periodoFinal: Yup.date().min(
      Yup.ref('periodoInicial'),
      'Data Inicial inválida.'
    ),
  });

  return (
    <div>
      <div
        className="w-100 d-flex align-items-center justify-content-between ps-3"
        style={{
          backgroundColor: '#1A1A1A',
        }}
      >
        <div className="d-flex align-items-center">
          <Image
            src={LogIcon}
            style={{ width: '1.6rem', height: '1.6rem' }}
            alt="Configurações"
          />
          <span
            className="text-white ms-2"
            style={{
              fontSize: '1.68rem',
              fontWeight: '600',
              backgroundColor: '#1A1A1A',
            }}
          >
            Log
          </span>
        </div>
        <div className="me-3">
          <div
            className="d-flex flex-column ms-2"
            role="button"
            tabIndex={0}
            onKeyPress={() => {
              setMaximizeLog(!maximizeLog);
              searchParams.set('maximizeLog', (!maximizeLog).toString());
              setSearchParams(searchParams);
            }}
            onClick={() => {
              setMaximizeLog(!maximizeLog);
              searchParams.set('maximizeLog', (!maximizeLog).toString());
              setSearchParams(searchParams);
            }}
          >
            <Image
              src={maximizeLog ? ResizeMaximizedIcon : ResizeIcon}
              style={{ width: '1.6rem', height: '1.6rem' }}
            />
          </div>
        </div>
      </div>
      <section className="p-2">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            // getHistoricoChat(values);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            isSubmitting,
            resetForm,
          }) => (
            <FormMik>
              <div
                className={`w-100 ${
                  maximizeLog ? 'd-flex justify-content-between' : ''
                }`}
              >
                <div className="d-flex align-items-center w-100">
                  <Form.Group className="p-0">
                    <Form.Label htmlFor="inputPeriodoInicial" className="mb-0">
                      Data Inicial
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="periodoInicial"
                      max="2999-12-31"
                      className={
                        (touched.periodoInicial || touched.periodoFinal) &&
                        errors.periodoFinal
                          ? 'is-invalid'
                          : 'p-0 inputBox'
                      }
                      onChange={(e) => {
                        handleChange(e);
                        initialValues.periodoInicial = e.target.value;
                      }}
                      onBlur={handleBlur}
                      value={initialValues.periodoInicial}
                    />
                    {touched.periodoFinal && errors.periodoFinal ? (
                      <div className="invalid-feedback">
                        {errors.periodoFinal}
                      </div>
                    ) : null}
                  </Form.Group>

                  <Form.Group className="p-0 ms-2">
                    <Form.Label htmlFor="inputPeriodoFinal" className="mb-0">
                      Data Final
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="periodoFinal"
                      max="2999-12-31"
                      className="p-0 inputBox"
                      onChange={(e) => {
                        handleChange(e);
                        initialValues.periodoFinal = e.target.value;
                      }}
                      value={initialValues.periodoFinal}
                    />
                  </Form.Group>

                  <Form.Group className="ms-2 w-75">
                    <Form.Label className="mb-0">Usuário</Form.Label>
                    <Form.Select
                      size="sm"
                      name="seqUsuario"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      value={values.seqUsuario}
                      className="inputBox"
                    >
                      <option value={0}>Todos</option>
                      {usuario.map((user) => (
                        <option key={user.seqUsuario} value={user.seqUsuario}>
                          {user.nome}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>
                <div
                  className={`d-flex align-items-center w-100 ${
                    maximizeLog ? 'ms-2' : ''
                  }`}
                >
                  <Form.Group className="w-50">
                    <Form.Label className="mb-0">Tabela</Form.Label>
                    <Form.Select
                      size="sm"
                      name="seqTabela"
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onBlur={handleBlur}
                      value={values.seqTabela}
                      className="inputBox"
                    >
                      <option value={0}>Todos</option>
                      {logTabela.map((tabela) => (
                        <option
                          key={tabela.seqLogTabela}
                          value={tabela.seqLogTabela}
                        >
                          {tabela.nome}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="ms-2 w-50">
                    <Form.Label className="mb-0"> </Form.Label>
                    <Form.Control
                      type="text"
                      name="nomeUsuario"
                      className="inputBox"
                      placeholder="Digite o nome do usuário ..."
                      value={values.nomeUsuario}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                    />
                  </Form.Group>
                  <Button
                    className="ms-2 mt-4 p-0"
                    style={{ height: '2.4rem', width: '2.4rem' }}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onClick={() => {
                      getLog(values);
                    }}
                  >
                    <Image
                      src={iconSearch}
                      alt="search"
                      className=""
                      style={{ height: '1.5rem' }}
                    />
                  </Button>
                </div>
              </div>
            </FormMik>
          )}
        </Formik>
      </section>
      <section
        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        <div
          className="mx-2"
          style={{
            flexShrink: 0,
            overflowY: 'auto',
            overflowX: 'auto',
            height: maximizeLog ? '21.8rem' : '17.5rem',
            border: '1px solid #ccc',
            borderRadius: '0.68rem',
          }}
        >
          <table
            className="table table-nowrap mb-0 table-striped-custom overflow-auto"
            style={{ borderRadius: '0.68rem', width: '100%' }}
          >
            <thead
              className="small fw-light text-dark"
              style={{
                backgroundColor: '#D9D9D9',
                fontSize: '1.25rem',
                position: 'sticky',
                top: 0,
                zIndex: 1,
              }}
            >
              <tr style={{ color: '#000' }}>
                <th
                  style={{ whiteSpace: 'nowrap', minWidth: '200px' }}
                  className=""
                >
                  Data
                </th>
                <th
                  style={{ whiteSpace: 'nowrap', minWidth: '200px' }}
                  className=""
                >
                  Usuário
                </th>
                <th style={{ whiteSpace: 'nowrap' }} className="">
                  Tabela Alterada
                </th>
                <th style={{ whiteSpace: 'nowrap' }} className="">
                  Operação
                </th>
              </tr>
            </thead>
            <tbody style={{ fontSize: '1.125rem' }}>
              {dataLog.map((log) => (
                <tr
                  key={log.seqLog}
                  style={{
                    color: log.seqLog === logSelected ? '#fff' : '#000',
                    backgroundColor:
                      log.seqLog === logSelected ? '#0075FF' : '',
                    fontWeight: '600',
                  }}
                  onClick={() => {
                    getLogDetalhe(log.seqLog);
                    setLogSelected(log.seqLog);
                  }}
                >
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <span>{formatLocalDateTime(log.dataOperacao)}</span>
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <span className="">
                      {getPrimeiroUltimoNome(log.nomeUsuario)}
                    </span>
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <span>{log.nomeTabela}</span>
                  </td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <span>{log.operacao}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div
          className="mx-2 mt-2 bg-amber-700 div-log-detail"
          style={{
            overflowY: 'auto',
            border: '1px solid #ccc',
            borderRadius: '0.68rem',
          }}
        >
          <table
            className="table table-nowrap mb-0 table-striped-custom"
            style={{ borderRadius: '0.68rem' }}
          >
            <thead
              className="small fw-light text-dark"
              style={{
                backgroundColor: '#D9D9D9',
                fontSize: '1.25rem',
                position: 'sticky',
                top: 0,
                zIndex: 1,
              }}
            >
              <tr style={{ color: '#000' }}>
                <th className="col-1">Campo</th>
                <th className="col-3">Conteúdo atual</th>
                <th className="col-3">Conteúdo anterior</th>
              </tr>
            </thead>
            <tbody style={{ fontSize: '1.125rem' }}>
              {dataLogDetalhe.map((logDetalhe) => (
                <tr
                  key={logDetalhe.seqLogDetalhe}
                  style={{
                    color: '#000',
                    fontWeight: '600',
                  }}
                >
                  <td className="">
                    <span>{logDetalhe.campo}</span>
                  </td>
                  <td className="col-1">
                    <span className="">{logDetalhe.conteudoAtual}</span>
                  </td>
                  <td className="col-2">
                    <span>{logDetalhe.conteudoAnterior}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};
export default ConfigLog;
